<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00001"><a class="calibre1" id="CONTENTS"></a>CONTENTS</h2>
<div class="center1">
<table border="0" cellpadding="4" cellspacing="0" class="calibre12" summary="Table of Contents.">
<tbody class="calibre13"><tr class="calibre14"><td class="calibre15"> </td>
<td class="pgno"><span class="small">PAGE</span></td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><a href="#/Text/Section0004#I">The Cabuliwallah</a></span></td>
<td class="pgno">3</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><a href="#/Text/Section0005#II">The Home-Coming</a></span></td>
<td class="pgno">21</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0006#III" title="Link target outside of Sample">Once there was a King</span></span></td>
<td class="pgno">35</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0007#IV" title="Link target outside of Sample">The Child's Return</span></span></td>
<td class="pgno">51</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0008#V" title="Link target outside of Sample">Master Mashai</span></span></td>
<td class="pgno">69</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0009#VI" title="Link target outside of Sample">Subha</span></span></td>
<td class="pgno">101</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0010#VII" title="Link target outside of Sample">The Postmaster</span></span></td>
<td class="pgno">115</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0011#VIII" title="Link target outside of Sample">The Castaway</span></span></td>
<td class="pgno">129</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0012#IX" title="Link target outside of Sample">The Son of Rashmani</span></span></td>
<td class="pgno">151</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0013#X" title="Link target outside of Sample">The Babus of Nayanjore</span></span></td>
<td class="pgno">203</td>
</tr>
<tr class="calibre14"><td class="desc"><span class="smcap"><span href="#/Text/Section0014#NOTES" title="Link target outside of Sample">Notes</span></span></td>
<td class="pgno">223</td>
</tr>
</tbody>
</table>
</div>
<p class="calibre3"><span id="pgepubid00002" title="[Pg 1]"><a id="Page_1" title="[Pg 1]"></a></span></p>
<p class="prechap"></p>
<p class="calibre3"><span id="pgepubid00004" title="[Pg 3]"><a id="Page_3" title="[Pg 3]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?55aff3d2